<template lang="pug">
fieldset(:disabled="loading")
  form(@submit.prevent="save")
    modal(active title="Manutenção da OS-m" @close="$emit('close')")
      div(slot="modal-body")
        .columns
          form-group.column.col-12(:label="'ordem_servico.assunto' | tModel" :validation="$v.form.assunto_id")
            assunto-picker(v-model="$v.form.assunto_id.$model" @selected="onSelectedAssunto")
          form-group.column.col-12(:label="'ordem_servico.usuario_responsavel' | tModel" :validation="$v.form.usuario_responsavel_id")
            fiscal-picker(v-model="$v.form.usuario_responsavel_id.$model")
          form-group.column.col-12(:label="'ordem_servico.analista' | tModel" :validation="$v.form.analista_id" v-if="assunto && assunto.permite_analise")
            fiscal-picker(v-model="$v.form.analista_id.$model")
          form-group.column.col-12(:label="'ordem_servico.situacao' | tModel" :validation="$v.form.situacao")
            select-ordem-servico-situacao(v-model="$v.form.situacao.$model" :situacoes='allowedSituacoes')
          form-group.column.col-12(:validation="$v.form.agendar")
            label.form-switch
              input(type="checkbox", v-model="$v.form.agendar.$model")
              i.form-icon
              | É necessário agendar
      .text-right(slot="modal-footer")
        button.btn.btn-primary(:disabled="$v.form.$invalid") Salvar
</template>

<script>
import { deepClone, sanitize } from "paliari-js-utils"
import { required } from "vuelidate/lib/validators"
import toastErrors from "@/lib/errors/toastErrors"

export default {
  vuex: {
    servicos: {
      actions: ["fetchMmanutencao"],
      getters: ["loading"],
      state: ["current", "status"],
    },
  },
  data() {
    return {
      form: {},
      allowedSituacoes: {
        andamento: "Em andamento",
        aguardando_distribuir: "Aguardando Distribuir",
        abertura: "Em Abertura",
        reaberto: "Reaberto",
        reabrindo: "Reabrindo",
        em_distribuicao: "Em distribuição",
        encerrada: "Encerrada",
        cancelada: "Cancelada",
      },
      assunto: null,
    }
  },
  computed: {
    protocoloTipos() {
      return this.$i18n.t("enums.db.enum_protocolo_tipo")
    },
  },
  validations() {
    const validations = {
      form: {
        usuario_responsavel_id: {},
        analista_id: {},
        agendar: {},
        situacao: { required },
        assunto_id: { required },
      },
    }

    if (this.assunto && this.assunto.exige_analise) {
      validations.form.analista_id = { required }
    }
    return validations
  },
  methods: {
    onSelectedAssunto(assunto) {
      this.$set(this, "assunto", assunto)
    },
    save() {
      this.fetchMmanutencao(this.form)
        .then(() => {
          this.$toaster.success("Alterado com sucesso")
          this.$emit("close")
        })
        .catch(e => toastErrors(e))
    },
  },
  created() {
    const rules = {
      id: true,
      usuario_responsavel_id: true,
      analista_id: true,
      agendar: true,
      assunto_id: true,
      situacao: true,
    }
    this.form = sanitize(deepClone(this.current), rules)
  },
}
</script>
